import { useEffect, useState } from "react";

export default function useScreenWidth() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenWidth;
}
export function useIsMobileScreen() {
  const screenWidth = useScreenWidth();
  const [isWideScreen, setIsWideScreen] = useState(screenWidth < 768);

  useEffect(() => {
    setIsWideScreen(screenWidth < 768);
  }, [screenWidth]);

  return isWideScreen;
}